import { useCallback } from "react";

import crmEnrichmentFiltersService from "../../services/filters";
import type {
    CrmEnrichmentJobFilterType,
    CrmEnrichmentJobObject,
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentJobType,
    CrmEnrichmentSource,
    EnrichmentJobMappingDTO,
} from "../../types/types";
import { CrmEnrichmentWizardSteps } from "../../types/types";
import { areMappingsValid } from "../../utils/mappingValidation";

type HookParams = {
    selectedJobType: CrmEnrichmentJobType | "";
    selectedJobObject: CrmEnrichmentJobObject | "";
    selectedJobRefreshPeriod: CrmEnrichmentJobRefreshPeriod;
    selectedEnrichmentSource: CrmEnrichmentSource;
    isApplyFiltersSelected: boolean | null;
    filters: readonly CrmEnrichmentJobFilterType[];
    mappings: readonly EnrichmentJobMappingDTO[];
};

/** @deprecated use useStatefullWizardStepsValidation instead */
const useWizardStepsValidation = ({
    selectedJobType,
    selectedJobObject,
    selectedJobRefreshPeriod,
    selectedEnrichmentSource,
    isApplyFiltersSelected,
    filters,
    mappings,
}: HookParams) => {
    const isNextButtonDisabled = useCallback(
        (activeStepIndex: CrmEnrichmentWizardSteps): boolean => {
            switch (activeStepIndex) {
                case CrmEnrichmentWizardSteps.TypeStep:
                    return !selectedJobType;
                case CrmEnrichmentWizardSteps.SettingsStep:
                    return selectedJobType === "scheduled"
                        ? !selectedJobObject || !selectedJobRefreshPeriod || !selectedEnrichmentSource
                        : !selectedJobObject || !selectedEnrichmentSource;
                case CrmEnrichmentWizardSteps.FiltersStep:
                    return (
                        isApplyFiltersSelected === null ||
                        !crmEnrichmentFiltersService.areFiltersValid({
                            isApplyFiltersSelected,
                            filters,
                        })
                    );
                case CrmEnrichmentWizardSteps.FieldsMappingStep:
                    return !areMappingsValid(mappings);
                case CrmEnrichmentWizardSteps.ReviewStep:
                    return !!selectedJobType && selectedJobType === "scheduled"
                        ? !selectedJobObject || !selectedJobRefreshPeriod || !selectedEnrichmentSource
                        : !selectedJobObject || !selectedEnrichmentSource;
                default:
                    return true;
            }
        },
        [
            selectedJobType,
            selectedJobObject,
            selectedJobRefreshPeriod,
            selectedEnrichmentSource,
            isApplyFiltersSelected,
            filters,
            mappings,
        ],
    );

    const isAllPreviousStepsValid = useCallback(
        (index: number) => Array.from({ length: index }, (_, i) => i).every((i) => !isNextButtonDisabled(i)),
        [isNextButtonDisabled],
    );

    return {
        isNextButtonDisabled,
        isAllPreviousStepsValid,
    };
};

export default useWizardStepsValidation;
